import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import { useFavorites } from "@/contexts/FavoritesContext";
import ListingCard from "@/components/ListingCard";
import EmptyState from "@/components/EmptyState";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Favorites() {
  const { t } = useI18n();
  const { ids, clear } = useFavorites();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (ids.length === 0) { setItems([]); return; }
    Promise.all(ids.map((id) => api.get(`/listings/${id}`).then((r) => r.data).catch(() => null)))
      .then((res) => setItems(res.filter(Boolean)));
  }, [ids]);

  return (
    <div className="container-app py-6 lg:py-12">
      <div className="flex items-baseline justify-between mb-6">
        <div>
          <div className="kicker">{t("nav.favorites")}</div>
          <h1 className="mt-1.5 font-display text-2xl lg:text-4xl font-extrabold text-brand-navy">{t("favorites.title")}</h1>
        </div>
        {items.length > 0 && (
          <Button variant="outline" size="sm" onClick={clear} data-testid="fav-clear">{t("favorites.clear")}</Button>
        )}
      </div>

      {items.length === 0 ? (
        <EmptyState
          icon={Heart}
          title={t("favorites.empty")}
          action={<Link to="/explorer" className="btn-primary" data-testid="fav-explore">{t("nav.explore")}</Link>}
        />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="favorites-grid">
          {items.map((l) => <ListingCard key={l.id} listing={l} />)}
        </div>
      )}
    </div>
  );
}
